<script setup></script>

<template>
  <footer>
    <div class="content">
      <p class="content-element-1">
        <a href="https://www.instagram.com/wspomnienia_z_wesela"
          >@wspomnienia z wesela</a
        >
      </p>
      <p class="content-element-2">
        <a class="content-element-link" href="tel:+48603633998"
          >+48 603 633 998</a
        >
      </p>
      <p class="content-element-3">
        <a
          class="content-element-link"
          href="mailto:kontakt@wspomnieniazwesela.pl?subject=Kontakt w sprawie strony"
          >kontakt@wspomnieniazwesela.pl</a
        >
      </p>
    </div>
    <div class="content-border"></div>
    <div class="content content__flex">
      <p class="content-element-1">
        <a
          class="content-element-link"
          href="https://wspomnieniazwesela.pl/policies/state"
        >
          {{ $t('appCore.footer.state') }}
        </a>
      </p>
      <p class="content-element-2">
        <a
          class="content-element-link"
          href="https://wspomnieniazwesela.pl/policies/privacy"
        >
          {{ $t('appCore.footer.policy') }}
        </a>
      </p>
    </div>
    <div class="copyright">
      <p class="copyright-element">
        Copyright © {{ new Date().getFullYear() }} - EventApp Software sp. z
        o.o.
      </p>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
footer {
  width: 100%;
  background-attachment: fixed;
  position: relative;
  transition: 0.5s ease all;
  z-index: 10;
  background-color: rgba($color: #000, $alpha: 30%);
  backdrop-filter: blur(30px);
  padding-top: 15px;
  padding-bottom: 25px;
  display: flex;
  flex-direction: column;
  gap: 9px;

  @media screen and (max-width: $media-max-phone) {
    padding-top: 12px;
  }

  .content {
    color: #fff8f3;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 2px;
    width: 80%;
    margin: auto;
    gap: 9px 35px;

    @media screen and (max-width: $media-max-phone) {
      font-size: 8px;
      gap: 9px;
    }

    &__flex {
      display: flex;
    }

    &__grid {
      display: grid;
      grid-template: auto / repeat(auto-fit, minmax(1fr, auto));
      grid-template-areas: 'element-1 element-2 element-3';

      @media screen and (max-width: $media-max-tablet) {
        grid-template-areas:
          'element-1 element-2'
          'element-3 element-3';
      }
    }

    @for $i from 1 through 3 {
      &-element-#{$i} {
        grid-area: element-#{$i};
        text-align: center;
        text-wrap: nowrap;
      }

      &-element {
        &-link {
          position: relative;
          text-decoration: none;
          display: inline-block;

          &::before,
          &::after {
            content: '';
            position: absolute;
            width: 0;
            height: 1px;
            bottom: 0;
            background-color: #fff8f3;
            transition: width 0.3s ease;
          }

          &::before {
            left: 50%;
            transform: translateX(-50%);
          }

          &::after {
            right: 50%;
            transform: translateX(50%);
          }

          &:hover::before,
          &:hover::after {
            width: 100%;
          }
        }
      }
    }

    &-border {
      border-bottom: 1px solid #fff8f3;
      padding-bottom: 5px;
      width: 40%;
      margin: auto;
      margin-bottom: 5px;

      @media screen and (max-width: $media-max-phone) {
        width: 50%;
        padding-bottom: 1px;
        margin-bottom: 1px;
      }
    }
  }
}

.copyright {
  position: absolute;
  bottom: 5px;
  right: 5px;
  display: flex;
  justify-content: center;
  margin: auto;

  @media screen and (max-width: $media-max-phone) {
    bottom: 2px;
  }

  &-element {
    margin: 0;
    color: #fff8f3;
    font-size: 9px;

    @media screen and (max-width: $media-max-phone) {
      font-size: 7px;
    }
  }
}
</style>
